module.exports = __webpack_public_path__ + "img/application_channel_chans.20d8e3b2.png";